import { render, staticRenderFns } from "./ModuleDeleteConfirm.vue?vue&type=template&id=b7d3cf44"
import script from "./ModuleDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./ModuleDeleteConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports